// extracted by mini-css-extract-plugin
export default {"image":"F3-z","loaded":"G3-z"};